import { defineMessages } from "react-intl";

const UPDATE_USER_FORM = "update-user-form";

const updateUserFormMessages = defineMessages({
  emailExists: {
    id: `${UPDATE_USER_FORM}.email-exists`,
    defaultMessage: 'Email address "{email}" already exists in our system.'
  },
  useAnotherEmail: {
    id: `${UPDATE_USER_FORM}.use-another-email`,
    defaultMessage: "Please use another email address."
  },
  updatedAccount: {
    id: `${UPDATE_USER_FORM}.updated-account`,
    defaultMessage: "Your account information has been updated."
  },
  unableToUpdateAccount: {
    id: `${UPDATE_USER_FORM}.unable-to-update`,
    defaultMessage:
      "Unable to update account information. Please try again later."
  }
});

export default updateUserFormMessages;
